import React, { useEffect, useMemo, useState } from 'react';
import { EnPageLayout } from '@/components/en/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {

  return (
    <EnPageLayout
      banner='/image/contacts-banner.png'
    >
      <>
        {getHead(navDetail)}
        <div dangerouslySetInnerHTML={{ __html: navDetail?.content }} />
      </>
    </EnPageLayout>

  );
};


